<template>
	<div class="Echartbox">
		<!-- 访问类型 -->
		<div id="caketyeEchart" ></div>
	</div>
</template>

<script>
	var that;
	import {
		randomArr
	} from "../js/billet.js"
	export default {
		name: "caketyeEchart",
		props: {
			dataobj: {
				type: Object,
				default: ()=>{
					return {}
				},
			},
		},
		data() {
			return {
				myChart: null,
				option: {
					// grid: {
					// 	left: '3%',
					// 	right: '4%',
					// 	bottom: '3%',
					// 	containLabel: true
					// },
					color: ['rgba(43, 117, 235, 1)', 'rgba(88, 226, 204, 1)',
						'rgba(36, 198, 255, 1)', 'rgba(185, 114, 245, 1)', 'rgba(255, 141, 26, 1)'
					],
					tooltip: {
						trigger: 'item',
						// formatter: '{b} : {c} ({d}%)'
					},
					legend: {
						orient: 'inherit',
						left: 'right',
						icon: "circle", //  这个字段控制形状  类型包括 circle 圆形，triangle 三角形，diamond 四边形，arrow 变异三角形，none 无
						itemWidth: 10, // 设置宽度
						itemHeight: 10, // 设置高度
						itemGap: 15, // 设置间距，
						formatter: function(name) {
							// 获取legend显示内容
							let data = that.option.series[0].data;
							let total = 0;
							let tarvalue = 0;
							let index = 0;
							for (let i = 0; i < data.length; i++) {
								total += data[i].value;
								if (data[i].name == name) {
									index = i
									tarvalue = data[i].value;
								}
							}
							let num = 0
							if(tarvalue && total){
								num = (tarvalue / total * 100).toFixed(2)
							}
							if(index == 0){
								return `${name}       ${tarvalue}     ${num}%`
							}
							else if(index == 1) {
								return `${name}       ${tarvalue}     ${num}%`
							}
							else if(index == 2) {
								return `${name}       ${tarvalue}     ${num}%`
							}
							else if(index == 3) {
								return `${name}       ${tarvalue}     ${num}%`
							}
							else {
								return `${name}       ${tarvalue}     ${num}%`
							}
							
						},
						textStyle: { // 图例文字的样式
						},
					},
					series: [
						{
						center: ['25%', '50%'],
						// name: 'Access From',
						type: 'pie',
						radius: '70%',
						label: {
							formatter: '{a} {b}: {d}%'
						},
						label: {
							show: false
						},
						data: [
							{
								value: 0,
								name: '名片'
							},
							{
								value: 0,
								name: '文章' 
							},
							{
								value: 0,
								name: '产品'
							},
							{
								value: 0,
								name: '表单'
							},
							{
								value: 0,
								name: '素材'
							}
						],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				},
			}
		},
		watch: {
			dataobj(){
				this.fn_SetDatas()
			},
		},
		created() {
			that = this
		},
		methods: {
			fn_SetDatas(){
				if(this.dataobj) {
					let len = this.option.series[0].data.length
					for(let i = 0; i < len;i++) {
						let currObj = this.option.series[0].data[i]
						if(i == 0) { // 名片    
							currObj.value = this.dataobj.card_num ? this.dataobj.card_num : 0;
						}
						else if(i == 1) {  // 文章
							currObj.value = this.dataobj.article_num ? this.dataobj.article_num : 0;
						}
						else if(i == 2) {  // 产品
							currObj.value = this.dataobj.goods_num ? this.dataobj.goods_num : 0;
						}
						else if(i == 3) {  // 表单
							currObj.value = this.dataobj.form_num ? this.dataobj.form_num : 0;
						}
						else if(i == 4) {  // 素材
							currObj.value = this.dataobj.material_num ? this.dataobj.material_num : 0;
						}
					}
					this.drawLine()
				}
			},
			drawLine() {
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById('caketyeEchart'))
				// 绘制图表
				myChart.setOption(this.option);
				this.$store.state.myChartAll.push(myChart);
				this.myChart = myChart;
			},
		},
	}
</script>

<style scoped lang="scss">
	.Echartbox {
		
		padding: 10px;
		width: 100%;
		background-color: #fff;
		position: absolute;
		height: 100%;
		#caketyeEchart{
			width: 100%;
			height: 100%;
		}
	}
</style>
